<template>
  <div class="fixed-char">
    <el-checkbox v-model="content.checked" @change="handlerCheckbox"></el-checkbox>

    <div class="serial-label">
      <span class="text-medium leading-22 ml-8 mr-3 text-theme-black-650">固定字符</span>
    </div>
    <el-input v-model="value" @blur="blurValue" placeholder="1-8位数字中英文或特殊字符" size="small" class="bg-white-input mr-3" style="width:312px" />
  </div>
</template>

<script>
export default {
  name: 'FixedChar',
  props: {
    content: Object
  },
  data() {
    return {
      value: ''
    }
  },
  methods: {
    getValue() {
      return this.value
    },
    setValue(val) {
      this.value = val
      this.$emit('format-change', val)
    },
    blurValue() {
      this.checkValue()
      if(this.content.checked) this.$emit('format-change', this.value)
      this.$emit('set-defaultValue', this.content.name, this.value)
    },
    checkValue() {
      let val = this.value
      const minLen = 1
      const maxLen = 8
      if (!this.validateFixedChar(val, minLen, maxLen)) {
        this.$message.warning(`请输入${minLen}-${maxLen}位数字中英文或特殊字符`)
        // 如果勾选了-判定为错
        if(this.content.checked) {
          this.$emit('check-value', false)
          return false
        }
      }
      this.$emit('check-value', true)
      return true
    },
    validateFixedChar(val, minLen = 0, maxLen) {
      let reg = new RegExp(`^.{${minLen},${maxLen}}$`)
      return reg.test(val)
    },
    handlerCheckbox(val) {
      if(val) {
        this.checkValue()
        this.$emit('format-change', this.value)
      } else {
        this.$emit('check-value', true)
        this.$emit('format-change', '')
      }
    }
  },
  created() {
    if (this.content.defaultValue) {
      this.setValue(this.content.defaultValue)
    }
  },
}
</script>

<style scoped>
</style>
